import * as sTypes from 'Flow2/components/Share/ShareTypes/ShareTypes';

export const replaceData = ({customSortOption}) => {
    if(customSortOption && customSortOption.field 
        && customSortOption.field == sTypes.REPLACE_SEARCH_OBJ.old){
            customSortOption.field = sTypes.REPLACE_SEARCH_OBJ.new;
    }
    return customSortOption;
}